import { useCaseFiles } from './useCaseFiles';
import { useRemoteStatusSummary } from './useRemoteStatusSummary';

export function useRemoteReadModel({
  config,
  debugLog,
  fetchApplicationFileStatusSummary,
  managementApiService,
  normalizeCaseFileRecords,
  mapStatusSummaryFilesToCaseFileRecords,
  normalizeDisplayName,
  getFirstRecordValue,
  getRecordMediaId,
  getRecordTranscriptFileId,
  getRecordFileType,
  getRecordScanStatus,
  getRecordLifecycleStatus,
  dedupeCaseFileRecordsExact,
  collectSubmittedAtTimedOutRemoteScanCandidates,
  processTimedOutRemoteScanCandidates,
  mergeRemoteStatuses,
  setMediaItems,
  mediaItemsRef,
  setInlineError,
  clearResolvedInlineWarningIfNeeded
}) {
  const {
    remoteStatusSummary,
    remoteStatusSummaryRef,
    refreshRemoteStatusSummary,
    resetRemoteStatusSummary
  } = useRemoteStatusSummary({
    config,
    debugLog,
    fetchApplicationFileStatusSummary,
    managementApiService
  });

  const {
    caseFiles,
    caseFilesLoading,
    caseFilesError,
    caseFilesRef,
    setCaseFiles,
    setCaseFilesError,
    fetchCaseFiles,
    loadCaseFiles
  } = useCaseFiles({
    config,
    debugLog,
    managementApiService,
    normalizeCaseFileRecords,
    mapStatusSummaryFilesToCaseFileRecords,
    normalizeDisplayName,
    getFirstRecordValue,
    getRecordMediaId,
    getRecordTranscriptFileId,
    getRecordFileType,
    getRecordScanStatus,
    getRecordLifecycleStatus,
    dedupeCaseFileRecordsExact,
    collectSubmittedAtTimedOutRemoteScanCandidates,
    processTimedOutRemoteScanCandidates,
    refreshRemoteStatusSummary,
    resetRemoteStatusSummary,
    mergeRemoteStatuses,
    setMediaItems,
    mediaItemsRef,
    setInlineError,
    clearResolvedInlineWarningIfNeeded
  });

  return {
    remoteStatusSummary,
    remoteStatusSummaryRef,
    refreshRemoteStatusSummary,
    resetRemoteStatusSummary,
    caseFiles,
    caseFilesLoading,
    caseFilesError,
    caseFilesRef,
    setCaseFiles,
    setCaseFilesError,
    fetchCaseFiles,
    loadCaseFiles
  };
}
